import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { propertyServices } from "../../../APIServices/GlobalManagements/propertyServices";
import { accountServices } from "../../../APIServices/GlobalManagements/accountServices";

const AddNewProperty = ({ show, hide, title, getPropertyList, organizationList, currentUserData }) => {
  const [loader, setLoader] = useState(false);
  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");
  const [accountId, setAccountId] = useState("");
  const [accountList, setAccountList] = useState([]);

  const addNewProperty = async () => {
    setLoader(true)
    let userData = {}
    userData.name = name
    userData.domain = domain
    if (currentUserData?.roleType === "organization") {
      userData.accountId = accountId
    }else{
      userData.accountId = currentUserData?.userId
    }
    let data = await propertyServices.addNewProperty(userData)
    if (data?.statusCode === 200) {
      getPropertyList()
      clearData();
    }
    setLoader(false)
  }

  const clearData = () => {
    setName("");
    setDomain("");
    setAccountId("");
    setLoader(false)
    hide();
  }

  const getAccountList = async (adminId) => {
    let data = await accountServices.getAccountList(adminId, "active")
    setAccountList(data?.data || [])
  }

  useEffect(() => {
    if (!show) {
      setName("");
      setDomain("");
      setAccountId("");
      setLoader(false)
      if (organizationList?.length === 1) {
        getAccountList(organizationList?.[0]?.adminId)
      }
    }
  }, [show]);
  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          {currentUserData?.roleType === "organization" &&
            <Form.Group className="mb-2">
              <Form.Label>Account</Form.Label>
              <Form.Select
                name="account"
                value={accountId}
                onChange={(e) => setAccountId(e.target.value)}
              >
                <option value="">Select Account</option>
                {accountList?.map(item => (
                  <option value={item?.accountId}>{item?.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
          }
          <Form.Group className="mb-2">
            <Form.Label>
              Website / App Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Website / App name"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Domain
            </Form.Label>
            <Form.Control
              name="userName"
              value={domain}
              onChange={(e) => setDomain(e.target.value)}
              placeholder="Enter Domain name (URL)"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
              Cancel
            </Button>
            <Button
              disabled={currentUserData?.roleType === "organization" ? (!accountId || !name || loader) : (!name || loader)}
              onClick={addNewProperty}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddNewProperty;
